import { useExportExaminationCodesByExamEventIdLazyQuery } from '@exam-center/graphql';
import { Button, FileDownloadOutlinedIcon } from '@shared/components';
import { useSnackbar } from '@shared/snackbar';
import { triggerFileDownload } from '@shared/utils';

import { useProctoringDetailsModal } from '../../providers';

interface PrintAllExaminationCodesButtonProps {
  shouldDisplayConfirmModal: boolean;
  examEventId: string;
}

export default function PrintAllExaminationCodesButton(
  props: Readonly<PrintAllExaminationCodesButtonProps>,
) {
  const { examEventId, shouldDisplayConfirmModal } = props;
  const { showSnackbar } = useSnackbar();

  const { setAction, close } = useProctoringDetailsModal();

  const [exportExaminationCodes] = useExportExaminationCodesByExamEventIdLazyQuery({
    variables: {
      exportExaminationCodesByExamEventIdInput: { examEventId },
    },
    fetchPolicy: 'no-cache',
  });

  const showSuccessSnackbar = () => {
    showSnackbar({
      message: 'ดาวน์โหลดใบแจ้งรหัสสอบสำเร็จ',
      variant: 'success',
    });
  };

  const showErrorSnackbar = () => {
    showSnackbar({
      message: 'ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่',
      variant: 'error',
    });
  };

  const handlePrintExaminationCodes = async () => {
    setAction({ action: 'print-examination-code-loading' });
    await exportExaminationCodes({
      onCompleted: (data) => {
        const pdfUrl = data.ecExportExaminationCodesByExamEventId.url;
        if (pdfUrl) {
          triggerFileDownload(pdfUrl);
          showSuccessSnackbar();
        } else {
          showErrorSnackbar();
        }
      },
      onError: () => {
        showErrorSnackbar();
      },
    });
    close();
  };

  const handleClick = async () => {
    if (shouldDisplayConfirmModal) {
      setAction({
        action: 'confirm-print-examination-code',
        data: {
          handleSubmit: handlePrintExaminationCodes,
        },
      });
    } else {
      await handlePrintExaminationCodes();
    }
  };

  return (
    <Button
      variant='outlined'
      color='secondary'
      onClick={handleClick}
      startIcon={<FileDownloadOutlinedIcon />}
    >
      ดาวน์โหลดใบแจ้งรหัสสอบทั้งหมด
    </Button>
  );
}
